//Importación de librerias
//---------------Forseti---------------
//Comunes
import FiltrosDeBusqueda from '../../../src/components/Forseti/Comun/FiltrosDeBusqueda.vue'
import PanelDeReproduccion from '../../../src/components/Forseti/Comun/PanelDeReproduccion.vue'
import PanelDeAccionesCamaras from '../../../src/components/Forseti/Comun/PanelDeAccionesCamaras.vue'
import Reproductor from '../../../src/components/Forseti/Comun/Reproductor.vue'


//Creamos y asignamos los datos necesarios de forseti
const forseti = [
  { Proviene: 'Forseti', Nombre: 'FiltrosDeBusqueda', datos: FiltrosDeBusqueda },
  { Proviene: 'Forseti', Nombre: 'PanelDeReproduccion', datos: PanelDeReproduccion },
  { Proviene: 'Forseti', Nombre: 'PanelDeAccionesCamaras', datos: PanelDeAccionesCamaras },
  { Proviene: 'Forseti', Nombre: 'Reproductor', datos: Reproductor }
]


//Exportamos los datos de forseti
export default forseti;




//////////////////
// WEBPACK FOOTER
// ./static/js/sistemas/forseti.js
// module id = null
// module chunks = 